const responseLoader = (payload) => {
  const tempOptions = {};

  const style = {
    minWidth: "fit-content",
    display: "flex",
    position: "relative",
    justifyContent: "center",
  };




  if (payload) {
    // console.log(payload+'pay')]

    payload.map((option, index) => {
      const fatherId = option["_id"];
      return (tempOptions[option["_id"]] = (
        <div style={style}>
          {/* {console.log(option.responses+'respionses')} */}
          {option.responses.map((response) => {


            return (
              <div
                style={{
                  minWidth: "fit-content",
                  borderRadius: "5px",
                  marginRight: "5px",
                  padding: "5px 10px",
                  backgroundColor: response.color,
                  textTransform: "capitalize",
                }}
              >
                {response.tag}
              </div>
            );

          })}
        </div>
      )
      );
    });
  }
  return tempOptions;
};

export default responseLoader;
